/**
 * GA4 event names (snake_case) as defined in the app-v2 event taxonomy
 * (RC-A-53). These are the names pushed to the GTM dataLayer. The widget emits
 * camelCase semantic events; the adapter in `widgetEventAdapter.ts` translates
 * them into these names + snake_case params.
 */
export const GA4Events = {
  APP_LOADED: 'app_loaded',

  ROUTE_REQUESTED: 'route_requested',
  ROUTE_NOT_FOUND: 'route_not_found',
  ROUTE_FETCH_FAILED: 'route_fetch_failed',
  ROUTE_CHANGED: 'route_changed',
  ROUTE_FEE_VIEWED: 'route_fee_viewed',

  SWAP_INITIATED: 'swap_initiated',
  SWAP_WALLETS_MODAL_SHOWN: 'swap_wallets_modal_shown',
  SWAP_WALLETS_CONFIRMED: 'swap_wallets_confirmed',
  SWAP_STARTED: 'swap_started',
  SWAP_COMPLETED: 'swap_completed',
  SWAP_FAILED: 'swap_failed',
  SWAP_STEP_STARTED: 'swap_step_started',
  SWAP_STEP_SUCCEEDED: 'swap_step_succeeded',
  SWAP_STEP_FAILED: 'swap_step_failed',
  SWAP_RESUMED: 'swap_resumed',
  SWAP_RETRIED: 'swap_retried',
  SWAP_CANCELLED: 'swap_cancelled',

  WALLET_CONNECTED: 'wallet_connected',
  WALLET_DISCONNECTED: 'wallet_disconnected',
  WALLET_CONNECT_INITIATED: 'wallet_connect_initiated',
  WALLET_CONNECT_FAILED: 'wallet_connect_failed',
  WALLET_DETECTED: 'wallet_detected',

  TOKEN_SELECTED: 'token_selected',
  CHAIN_FILTER_APPLIED: 'chain_filter_applied',
  SETTINGS_CHANGED: 'settings_changed',
  DESTINATION_ADDRESS_SET: 'destination_address_set',
  GAS_WARNING_SHOWN: 'gas_warning_shown',
  GAS_WARNING_BYPASSED: 'gas_warning_bypassed',

  PROFILE_LOGIN_INITIATED: 'profile_login_initiated',
  PROFILE_LOGIN_COMPLETED: 'profile_login_completed',
  PROFILE_LOGIN_FAILED: 'profile_login_failed',
  PROFILE_MERGE_INITIATED: 'profile_merge_initiated',
  PROFILE_MERGE_COMPLETED: 'profile_merge_completed',
  PROFILE_MERGE_FAILED: 'profile_merge_failed',
} as const;

export type GA4EventName = (typeof GA4Events)[keyof typeof GA4Events];
